import { SubOption } from 'models/option';
import { SubOptionFormActions } from '../reducer';

export default function setFormValue(dispatch) {
  return (subOption: SubOption) => {
    dispatch({ type: SubOptionFormActions.SET_FORM_VALUE, payload: subOption });
  };
}
